import React, { Component } from 'react'
import { HBBModal } from '../../../Modal/Components'
import { AddSkuModalLayout } from '../ModalLayout'

class AddSku extends Component {
    constructor() {
        super()
        this.state = {
            isAddSkuModalOpened: false,
        }
    }
    opeAddSkuModal = () => {
        this.setState({ isAddSkuModalOpened: true })
    }

    controlOpenCloseOfModal = (status) => {
       this.setState({ isAddSkuModalOpened: status })
    }

    render() {
        let modalComponent = null

        if (this.state.isAddSkuModalOpened) {
            modalComponent =
                <HBBModal>
                    <AddSkuModalLayout data={this.props.data} title={this.props.title}
                        closeModal={this.controlOpenCloseOfModal}
                        />
                </HBBModal>
        }
        return (
            <div>
                {modalComponent}
                {(()=>{
                    if(this.props.title==="Edit"){
                        return(
                            <button
                    className="btn btn-primary button-custom button-custom-edit"
                     onClick={(e) => {
                        e.preventDefault()
                        this.opeAddSkuModal()
                    }}>
                    Edit Menu
                </button>
                        )
                    }else{
                        return(
                            <button
                        className="btn btn-primary button-custom button-custom-edit"
                         onClick={(e) => {
                            e.preventDefault()
                            this.opeAddSkuModal()
                        }}>
                        Edit Menu
                    </button>
                        )
                    }

                })()}
                
            </div>
        )
    }
}

export default AddSku


// WEBPACK FOOTER //
// ./src/modules/Menus/Components/ActionButtons/AddSku.js